define( 'spinner',[ 'jquery' ],
	function( $ ) {
		'use strict';

		var Spinner = function( $targetEl ) {

			this.$targetEl = $targetEl;
			return this;
		};

		Spinner.prototype.load = function() {

			this.$spinner = $( '<div class="spinner"></div>' );
			this.$targetEl.append( this.$spinner );
		};

		Spinner.prototype.unload = function() {

			this.$spinner.fadeOut( 200, $.proxy( this.destroy, this ) );
		};

		Spinner.prototype.destroy = function() {

			this.$spinner.remove();
		};

		return Spinner;

	} );

